(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery thumbnails
  var mainImg = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      mainImg.alt = thumb.alt;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Variant price + availability updates
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variantsEl = document.querySelector('[data-product-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var select = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var button = form.querySelector('[data-add-to-cart]');

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.SHOP_CURRENCY || 'USD' });
    }

    function update() {
      if (!select) return;
      var v = variants.find(function (x) { return String(x.id) === String(select.value); });
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
      }
    }
    if (select && select.tagName === 'SELECT') select.addEventListener('change', update);
    update();
  }
})();
